import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>404</h1>
      <p style={styles.message}>Oops! The page you’re looking for doesn’t exist.</p>
      <Link to="/" style={styles.button}>
        Go Back Home
      </Link>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#f7fafc',
  },
  heading: {
    fontSize: '72px',
    fontWeight: 'bold',
    color: '#2d3748',
    margin: 0,
  },
  message: {
    marginTop: '16px',
    fontSize: '20px',
    color: '#718096',
  },
  button: {
    marginTop: '24px',
    padding: '10px 20px',
    backgroundColor: '#90EE90',
    color: '#ffffff',
    borderRadius: '8px',
    textDecoration: 'none',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },
};

export default NotFound;
